import { Divider, Stack } from '@chakra-ui/react';
import {
	ENVIRONMENT_VARIABLES,
	PROVIDER,
	sourceControlIntegrationIdNameSpaces,
} from '../create-project/helpers';
import { ESourceControl } from '../../../@xmcloud/types';
import { EnvVars } from '../../features/custom-environment-variables';
import { thirdStep } from '../../../@xmcloud/core/messages/en';
import { CmEnvironment } from './CmEnvironment';
import { useCreateEditEnvContext } from './hooks/CreateEditEnvContext';
import { LoadingSkeleton } from './LoadingSkeleton';
import {
	AdoRepository,
	EnvironmentName,
	EnvironmentVariables,
	GithubRepository,
	Options,
	SetupProviderAccount,
} from '../../features/common-env-fields';
import { useOrgProdCheckboxState } from '../../services/organizations';

const { info1, info4, nameCmEnv, nameEhEnv } = thirdStep;

const { ADO, GitHub } = ESourceControl;

const repoLookup = {
	[ADO]: (props: any) => <AdoRepository {...props} />,
	[GitHub]: (props: any) => <GithubRepository {...props} />,
	'': () => <></>,
};

export const EnvironmentFields: React.FC = () => {
	const {
		values,
		errors,
		touched,
		handleChange,
		setErrors,
		setFieldTouched,
		setValues,
		setTouched,
		setFieldValue,
		accessToken,
		isIntegrationIdValidationValid,
		integrationValidationErrorMsg,
		isLoading,
		isCm,
		isCreate,
		initialLoading,
		initialIntegrationId,
		initialIntegrationLabel,
		initialIntegrationProvider,
		isConnectionFromAnotherOrg,
		initialRepository,
		initialRepositoryId,
		initialRepositoryBranch,
		initialAdoOrganization,
		initialAdoProjectName,
	} = useCreateEditEnvContext();

	const { showCheckbox, showHelperText } = useOrgProdCheckboxState();
	const showProductionCheckbox = isCm && showCheckbox;

	const CurrentRepository = repoLookup[values[PROVIDER]];
	const sourceControlIntegrationIdNameSpace =
		sourceControlIntegrationIdNameSpaces['default'];
	const shouldShowInitialValues =
		isConnectionFromAnotherOrg &&
		initialIntegrationId === values[sourceControlIntegrationIdNameSpace];

	if (initialLoading) return <LoadingSkeleton />;

	return (
		<Stack gap="6" pl={3}>
			<EnvironmentName
				{...{
					values,
					errors,
					touched,
					handleChange,
					setFieldTouched,
					helperText: isCm ? info1 : info4,
					label: isCm ? nameCmEnv : nameEhEnv,
				}}
			/>
			{!isCm && <CmEnvironment />}
			<Divider />
			<SetupProviderAccount
				{...{
					values,
					errors,
					touched,
					setValues,
					setTouched,
					setErrors,
					setFieldTouched,
					isIntegrationIdValidationValid,
					integrationValidationErrorMsg,
					isSourceControlIntegrationLoading: isLoading,
					isCmEnv: isCm,
					initialIntegrationId,
					initialIntegrationLabel,
					initialIntegrationProvider,
					isConnectionFromAnotherOrg,
					initialRepository,
					initialRepositoryId,
					initialRepositoryBranch,
					initialAdoOrganization,
					initialAdoProjectName,
				}}
			/>
			<CurrentRepository
				{...{
					isSourceControlIntegrationLoading: isLoading,
					accessToken,
					values,
					errors,
					touched,
					setValues,
					setFieldTouched,
					setFieldValue,
					showRepoCombobox: true,
					isByoc: true,
					handleChange,
					initialRepository: shouldShowInitialValues
						? initialRepository
						: '',
					initialRepositoryBranch: shouldShowInitialValues
						? initialRepositoryBranch
						: '',
					initialAdoOrganization: shouldShowInitialValues
						? initialAdoOrganization
						: '',
					initialAdoProjectName: shouldShowInitialValues
						? initialAdoProjectName
						: '',
				}}
			/>
			<Divider />
			<Options
				{...{
					values,
					errors,
					setFieldValue,
					showProductionCheckbox,
					showHelperText: isCm && showHelperText,
					isProductionCheckboxReadOnly: !isCreate,
				}}
			/>
			<Divider />
			{isCreate && (
				<EnvVars
					{...{
						isExistingProject: false,
						initialVariables: values.environmentVariables,
						onVariablesChange: (variables) => {
							setFieldValue(ENVIRONMENT_VARIABLES, variables);
						},
					}}
				>
					<EnvironmentVariables
						variables={values.environmentVariables}
						minW={['full']}
					/>
				</EnvVars>
			)}
		</Stack>
	);
};
